export const phone = ['+', '7', '(', /[0-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
export const iin = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
export const IBAN = [
    'K', 'Z', 
    /\d/, /\d/,                
    /\d/, /\d/, /\d/,          
    /[0-9A-Z]/,/[0-9A-Z]/,/[0-9A-Z]/,/[0-9A-Z]/,/[0-9A-Z]/, 
    /[0-9A-Z]/,/[0-9A-Z]/,/[0-9A-Z]/,/[0-9A-Z]/,/[0-9A-Z]/,
    /[0-9A-Z]/,/[0-9A-Z]/,/[0-9A-Z]/
  ];
export const DOCUMENT_NUMBER = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]

export const MASK = {
    PHONE: phone,
    IIN: iin,
    IBAN,
    DOCUMENT_NUMBER,
};